import { getApi, patchApi, putApi } from "../../../helpers/auth_helpers";

const base = () => String(process.env.REACT_APP_SERVERURL || "").replace(/\/+$/, "");

/** The same list endpoint the editor uses: one piece with its draft overlay and price permissions. */
export const fetchProductForView = async (productUniqueId: string): Promise<any | null> => {
  const url = `${base()}/product/products?offset=0&limit=1&productId=${encodeURIComponent(productUniqueId)}`;
  const res = await getApi(url);
  const docs = res?.data?.docs;
  return Array.isArray(docs) && docs.length ? docs[0] : null;
};

/**
 * Saves exactly the fields given, nothing else: no media, no prices, no stock, no identity.
 * The body is the one object the caller built; it is never merged with the product.
 */
export const patchProductFields = (mongoId: string, fields: Record<string, unknown>) =>
  patchApi(`${base()}/product/${encodeURIComponent(mongoId)}/fields`, { fields });

export const saveProductPrices = (mongoId: string, sellPrice: string, costPrice: string) =>
  putApi(`${base()}/product/prices`, { id: mongoId, sellPrice, costPrice });

export const saveProductStock = (mongoId: string, inStock: boolean) =>
  putApi(`${base()}/product/in-stock`, { id: mongoId, inStock });
